import React, { useEffect, useState, forwardRef, useImperativeHandle } from "react";
import { useValidationErrorHandle } from "sr/helpers/functions/validationErrorHandle";

type Props = {
  data: { description?: string };
  HandleDataProps: (payload: { description: string }) => void;
};

const BidDescriptionChange = forwardRef(({ data, HandleDataProps }: Props, ref) => {
  const [desc, setDesc] = useState("");
  const [errorId, setErrorId] = useState<string>("");
  const validationErrorHandle = useValidationErrorHandle();

  useEffect(() => {
    setDesc(data?.description || "");
  }, [data?.description]);

  useImperativeHandle(ref, () => ({
    validateData: () => {
      if (!desc.trim()) { setErrorId('INPUT.VALIDATION.BID.DESCRIPTION'); return false; }
      setErrorId('');
      return true;
    },
    submitForm: () => {
      const newData = { description: desc.trim() };
      HandleDataProps(newData);
      return newData;
    },
  }));

  return (
    <div>
      <p className="pt-4 text-base">Project Approach & Description</p>
      <textarea
        className="w-full border rounded-lg p-2 mt-2"
        value={desc}
        onChange={(e) => setDesc(e.target.value)}
        placeholder="Explain your approach to this project"
        rows={4}
      />
      {errorId && <p className="text-red-500 text-sm mt-2">{validationErrorHandle(errorId)}</p>}
    </div>
  );
});

export default BidDescriptionChange;
